module.exports = __webpack_public_path__ + "img/weddings_24_H.4fc4a6f2.webp";